function relativeUrl(url: URL): string {
  return `${url.pathname}${url.search}${url.hash}`;
}

/** What the page someone is signing in for needs, beyond any session: `account` rules out guests. */
export type SignInRequirement = "account";

export function signInErrorCallback(next: string, requires?: SignInRequirement): string {
  const url = new URL("/login", window.location.origin);
  url.searchParams.set("next", next);
  if (requires) url.searchParams.set("requires", requires);
  return relativeUrl(url);
}

/**
 * Where a guest connecting a provider on `/create-account` comes back to: with `guestUpgrade`
 * when it worked, which the root finishes, or with the provider's `error` for the screen to say.
 */
export function createAccountUrls(next: string): { callbackURL: string; errorCallbackURL: string } {
  const error = new URL("/create-account", window.location.origin);
  error.searchParams.set("next", next);
  const callback = new URL(error);
  callback.searchParams.set("guestUpgrade", "success");
  return { callbackURL: relativeUrl(callback), errorCallbackURL: relativeUrl(error) };
}

export function guestUpgradeUrls(): {
  callbackURL: string;
  errorCallbackURL: string;
} {
  const callback = new URL(window.location.href);
  callback.searchParams.set("guestUpgrade", "success");
  callback.searchParams.delete("error");

  const error = new URL(callback);
  error.searchParams.set("guestUpgrade", "failed");

  return {
    callbackURL: relativeUrl(callback),
    errorCallbackURL: relativeUrl(error),
  };
}
